import React from 'react'
import { Button } from '@mui/material'

import { useSelector, useDispatch } from 'react-redux';
import { setLogin } from '../redux/loginSlice';


const LogoutButton = () => {
    const dispatch = useDispatch();
    const login = useSelector(state => state.login.value);

    const handleLogout = () => {
      // make a get fetch request to the server to log out
      fetch("https://werkvoorbereiding.divoduurzaam.nl/assets/php/security/logout.php", {
        method: "GET"
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        dispatch(setLogin(false));
      })
      .catch(error => {
        console.log(error);
      })
    }


  return (
    <Button 
        sx={{margin: '15%'}}
        variant="contained"
        color="primary"
        onClick={() => {
            handleLogout();
        }}
    >
        Log out
    </Button>
  )
}

export default LogoutButton